

<div class="title">
  <h1>{{'Safety Observation Dashboard' | translate | async}}</h1>
</div>
<div class="con">
  
  <div style="text-align: center;" >
    <div style="font-size: 18px;">
    <mat-form-field >
      <h4 style=" font-size: 18px;" class="get-label">{{'State' | translate | async}}</h4>
      <mat-select (selectionChange)="reloadfields()"  [(ngModel)]="stateID" name="Site" [formControl]="state" required>            
        <mat-option [value]="0">{{'All States' | translate | async}}</mat-option>
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select> 
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
 
    
    <mat-form-field class="header-form-full-width invisible"  >
      <mat-select name="name"  class="invisible" >
    </mat-select>
    </mat-form-field>

    <mat-form-field>
      <h4 style=" font-size: 18px;" class="get-label">{{'Observation Type' | translate | async}}</h4>
      <mat-select (selectionChange)="changeobservationtype($event)" [(ngModel)]="inputValueSefetyObservation" name="sefetyobservation" required>            
        <mat-option [value]="1">{{'Work Area' | translate | async}}</mat-option>
        <mat-option [value]="2">{{'Office' | translate | async}}</mat-option>
        <mat-option [value]="4">{{'All' | translate | async}}</mat-option>

        </mat-select> 
    </mat-form-field>
 
    <mat-form-field class="header-form-full-width invisible"  >
      <mat-select name="name1"  class="invisible" >
    </mat-select>
    </mat-form-field>

    <mat-form-field >
      <h4 style=" font-size: 18px;" class="get-label">{{'Month-Year' | translate | async}}</h4>
      <mat-select  (valueChange)="changeValue($event)"  name="month" required [(ngModel)]="inputValueMonth" [value] = "inputValueMonth" [disabled]="state.hasError('required')" >            
        <mat-option *ngFor="let month of monthList" [value]="month.Id">
          {{month.Name}} </mat-option>
        </mat-select>  
    </mat-form-field>
  </div>



  <!-- <div style="display: flex;flex-wrap: wrap">
  <div class="sc-dashboard-category">
    <div class="chartjs-size-monitor">
      <div class="chartjs-size-monitor-expand">
        <div class="chartjs-size-monitor-shrink">

        </div>
      </div>

    </div>
    <div class="centered-header">

    </div>
  </div>
  </div> -->


  <div  style="display: flex; flex-wrap: wrap;">
    <div  class="sc-dashboard-category">
        <h4 class="centered-header"><u>{{Inspections}} {{'Inspections' | translate | async}} / {{Observations}} {{'Observations' | translate | async}}</u></h4>
        <!-- <h4 class="centered-header"><u>{{Observations}} Observations</u></h4> -->

        <!-- <canvas id="dashboard-summary-chart" style="display: block; width: 364px; height: 182px; " width="364" height="182" class="chartjs-render-monitor" ></canvas> -->
        <div style="display: block">
          <!-- <canvas baseChart
                      [data]="demodoughnutChartData"
                      [labels]="doughnutChartLabels"
                      [chartType]="doughnutChartType"
                      (chartHover)="chartHovered($event)"
                      (chartClick)="chartClicked($event)"></canvas> -->
<fusioncharts
  [width]="width"
  [height]="height"
  [type]="type"
  [dataFormat]="dataFormat"
  [dataSource]="dataSource"
>
</fusioncharts>
        </div>
    </div>
<ng-container *ngFor="let category of CategorySummary">

        <div class="sc-dashboard-category">
          <h4 class="centered-header">{{category.CategoryName}}</h4>
            <ng-container *ngIf="category.Questions != null">
              <ng-container *ngFor="let question of category.Questions">
 
                    <div class="sc-dashboard-questions"> 
                     
                        <!-- <div class="sc-safe sc-dashboard-question-summary" [style.flex]="SafePct"></div> -->
                        <!-- <div class="sc-unsafe sc-dashboard-question-summary" [style.flex]="UnsafePct"></div>
                        <div  class="sc-default-noh sc-dashboard-question-summary" [style.flex]="UnansweredPct"></div> -->

                        <div class="sc-safe sc-dashboard-question-summary" [style.flex]="question.Safe*100/(question.Safe + question.Unanswered + question.Unsafe)"></div>
                        <div class="sc-unsafe sc-dashboard-question-summary" [style.flex]="question.Unsafe*100/(question.Safe + question.Unanswered + question.Unsafe)"></div>
                        <div  class="sc-default-noh sc-dashboard-question-summary" [style.flex]="question.Unanswered*100/(question.Safe + question.Unanswered + question.Unsafe)"></div>

                        <div class="sc-dashboard-question-title">{{question.QuestionName}}</div>
                    
                  </div>
                    <span></span>
                    
              </ng-container>
            
            </ng-container>
        </div>
    
    </ng-container>

</div>

  </div>
  </div>
   